<template>
    <!-- 下拉菜单 -->
    <nav class="drop-drown">
        <a-menu v-model="current" mode="horizontal" @click="handleClick">
            <template v-for="(item,index) in menuList" >
                <a-menu-item  v-if="item.child.length==0" :key=item.url > {{item.title_name}}</a-menu-item>
                <a-sub-menu  v-else :key="item.id" >
                    <span slot="title" class="submenu-title-wrapper" :key="item.parent_id" >{{item.title_name}}</span>
                    <a-menu-item-group v-for="(lineItem) in item.child" :key="lineItem.url">
                        
                        <a-menu-item :key="lineItem.url" style="text-align: center;margin-bottom: 0;padding: 0 .125rem;"  >{{lineItem.title_name}}</a-menu-item>
                        <a-menu-divider :key="lineItem.parent_id" v-if="index==menuList.length-1" />
                    </a-menu-item-group>
                  
                    <!-- <a-menu-item key="/product/ai" style="text-align: center;margin-bottom: 0;padding: 0 .125rem;">视觉AI</a-menu-item>
                    <a-menu-divider />
                    <a-menu-item key="/product/iot" style="text-align: center;margin-bottom: 0;padding: 0 .125rem;">IOT</a-menu-item>
                    <a-menu-divider />
                    <a-menu-item key="/product/intelligence" style="text-align: center;margin-bottom: 0;padding: 0 .125rem;">智能仓储物流</a-menu-item> -->
                </a-sub-menu>
            </template>
       
        
        <!-- <a-sub-menu>
            <span slot="title" class="submenu-title-wrapper">产品介绍</span>
            <a-menu-item key="/product/mes" style="text-align: center;margin-bottom: 0;padding: 0 .125rem;" >MES</a-menu-item>
            <a-menu-divider />
            <a-menu-item key="/product/ai" style="text-align: center;margin-bottom: 0;padding: 0 .125rem;">视觉AI</a-menu-item>
            <a-menu-divider />
            <a-menu-item key="/product/iot" style="text-align: center;margin-bottom: 0;padding: 0 .125rem;">IOT</a-menu-item>
            <a-menu-divider />
            <a-menu-item key="/product/intelligence" style="text-align: center;margin-bottom: 0;padding: 0 .125rem;">智能仓储物流</a-menu-item>
        </a-sub-menu>
        <a-menu-item key="/resolution">解决方案</a-menu-item>
        <a-menu-item key="/servicelist">服务案例</a-menu-item>
        <a-menu-item key="/service">服务专区</a-menu-item> -->
        <!-- <a-sub-menu>
            <span slot="title" class="submenu-title-wrapper">服务专区</span>
            <a-menu-item key="service" style="text-align: center;margin-bottom: 0;padding: 0 .125rem;" >服务范围</a-menu-item>
            <a-menu-divider />
            <a-menu-item key="service" style="text-align: center;margin-bottom: 0;padding: 0 .125rem;">服务流程</a-menu-item>
            <a-menu-divider />
            <a-menu-item key="service" style="text-align: center;margin-bottom: 0;padding: 0 .125rem;">服务体系</a-menu-item>
        </a-sub-menu> -->
        <!-- <a-menu-item key="/news">新闻资讯</a-menu-item>
        <a-menu-item key="/about">关于我们</a-menu-item> -->
        <!-- <a-sub-menu>
            <span slot="title" class="submenu-title-wrapper">关于我们</span>
            <a-menu-item key="about" style="text-align: center;margin-bottom: 0;padding: 0 .125rem;" >公司简介</a-menu-item>
            <a-menu-divider />
            <a-menu-item key="about" style="text-align: center;margin-bottom: 0;padding: 0 .125rem;">团队风采</a-menu-item>
            <a-menu-divider />
            <a-menu-item key="about" style="text-align: center;margin-bottom: 0;padding: 0 .125rem;">联系方式</a-menu-item>
            <a-menu-divider />
            <a-menu-item key="about" style="text-align: center;margin-bottom: 0;padding: 0 .125rem;">在线留言</a-menu-item>
        </a-sub-menu> -->
        </a-menu>
    </nav>
</template>
<script>
import {getTitleList} from '@/api/index'
export default {
  data() {
    return {
      current: ['/home'],
      menuList:[],
      title_id:""
    };
  },
  watch:{
    $route: {
        handler: function(val, oldVal){
            console.log(val,'val');
            console.log(val,'val');
            this.current=[`${val.path}`]
            if(val.path=='/news/newslist'){
                this.current=[`/news`]
            }else if(val.path=="/service/servicelist"){
                this.current=[`/servicelist`]
            }
        },
    // 深度观察监听
        deep: true
    }
  },

  methods:{
    handleClick(item){
        item.name=item.key.split("/")[item.key.split("/").length-1]
        this.title_id=""
        this.menuList.forEach((items)=>{
           if(items.url==item.key ){
            this.title_id= items.id
           }else{
            if(items.child){
                items.child.forEach((lineItem)=>{
                    if(lineItem.url==item.key){
                        this.title_id= items.id
                    }
                })
            }
           }
        })
        if( item.name=="news"){
            item.name="newslist"
        }
        if(this.$route.name==item.key){
            this.$router.go(0)
        }else{
            // this.$router.push(`${item.key}`)
            // let title_name=item.key
            // console.log(this.title_i,'this.title_id');
            sessionStorage.setItem('title_id',this.title_id)
            sessionStorage.setItem('product',item.name)
            this.$router.push({name:`${item.name}`,params:{title_id:this.title_id} })
        }
    },
    getTitleList(){
        getTitleList().then((res)=>{
            // console.log(res,'res==========');
            this.menuList=res.data
        })
    }
  },
  created(){
    this.getTitleList()
    if(this.$route.path=='/news/newslist'){
        this.current=[`/news`]
    }else if(this.$route.path=='/service/servicelist'){
        this.current=[`/servicelist`]
    }else{
        this.current=[`${this.$route.path}`]
    }
  },
};
</script>
<style lang="scss" >
.drop-drown{
    // width: 9.925rem;
    height: 1.25rem;
    display: flex;
    font-size: $font-size18 !important;
    .ant-menu-horizontal {
        line-height: .75rem!important;
    }
    .ant-menu {
        font-size:$font-size18;
    }

    .ant-menu-item{
        // padding: .2125rem 0;
        padding-top:.225rem;
        padding-bottom:.25rem ;
        padding-left: .25rem;
        padding-right: .25rem;
        // margin: 0 .25rem;
        // font-family: PingFang SC, PingFang SC;
        // font-weight: 500;
        // color: #222222;
        // line-height: .7875rem;
     
        .ant-menu-vertical {
            .ant-menu-item:not(:last-child){
                margin-bottom: 0!important;
            }
        }
       
    }
  
   
}
.ant-menu-vertical.ant-menu-sub{
        font-size: $font-size16!important;
    }
    .ant-menu-vertical .ant-menu-item{
        font-size: $font-size16!important;
    }

</style>